import { Toast } from '../Toast/Toast';

export const UpdateVersionAlert = () => {
  const handleRefresh = () => {
    const { pathname, search, hash } = window.location;
    window.location.replace(pathname + search + hash);
  };

  return (
    <Toast
      severity="warning"
      title="New version available"
      description="Please refresh the page to update"
      secondaryActionLabel="Refresh"
      onSecondaryAction={handleRefresh}
      position="bottom"
    />
  );
};
